import { IPwaConfig } from '@ta/capacitor';
import { IGTMConfig } from '@ta/core';
import { IGraphConfig, IRestConfig, IStrapiConfig } from '@ta/server';

export const baseEnvironment: {
  development: boolean;
  version: string;

  DEBUG: boolean;
  DEBUG_LEVEL: number;

  GRAPHQL_SERVER_CONFIG: IGraphConfig;
  REST_SERVER_CONFIG: IRestConfig;

  STRAPI_SERVER_CONFIG: IStrapiConfig;

  APP_NAME: string;
  MAIN_COLOR: string;
  PWA: IPwaConfig;
  /** Enregistre le service worker (cache ngsw + Web Push), y compris en configuration development. */
  SERVICE_WORKER: boolean;

  TRANSLATION: {
    DEFAULT: string;
    SUPPORTEDLANGUAGES: string[];
  };

  GTM: IGTMConfig;

  IDENTITY_PROVIDERS: {
    itsme: boolean;
    veriff: boolean;
  };

  FEATURES: {
    searchMenu: boolean;
  };

  VITRINE_URL: string;

  /** Clé Google Maps (Places) : autocomplétion d'adresse de @ta/form-input. */
  GOOGLE_MAPS_API_KEY: string;

  AUTH0: {
    domain: string;
    clientId: string;
    cacheLocation: 'localstorage';
    // Request this audience at user authentication time
    authorizationParams: {
      audience: string;
      redirect_uri: string;
    };

    // Specify configuration for the interceptor
    httpInterceptor?: {
      allowedList: {
        uri: string;
        allowAnonymous: boolean;
      }[];
    };
  };
} = {
  development: false,
  version: '0.0.1',

  DEBUG: false,
  DEBUG_LEVEL: 0,

  GRAPHQL_SERVER_CONFIG: {
    url: 'https://bailoapi-app-20250826203204.calmgrass-23d7e508.francecentral.azurecontainerapps.io/graphql',
    local_urls: {
      user: '',
    },
  },
  REST_SERVER_CONFIG: {
    pendindRequestId: 5,
    serverUrl:
      'https://bailoapi-app-20250826203204.calmgrass-23d7e508.francecentral.azurecontainerapps.io/api',
  },
  STRAPI_SERVER_CONFIG: {
    url: 'https://strapi.didi-home.com/graphql',
    // TODO: SECURITY - Inject via CI/CD environment variables
    token:
      '26392b7e68bcaf00a7a1ab8a124957c3b3fa81d92c3cefcc89ed60734d409b8696734c7f718769243106c9617f84cc574a5219b9282b4c13f770158be82b20d391351aa0f352e3f5e5ecd7d5f326ae9baba4b0ae8232eef17f20058e4bb92de41273762111ea5f8f84fe258eb718d6e862eea5f7c8186388ce28810a39f27b69',
  },
  GTM: {
    gtmId: 'GTM-P8STX74L',
    enabled: false,
  },

  APP_NAME: 'Bailo dashboard',
  MAIN_COLOR: 'white',
  PWA: {
    active: true,
  },
  SERVICE_WORKER: true,

  TRANSLATION: {
    DEFAULT: 'fr',
    SUPPORTEDLANGUAGES: ['fr', 'en', 'nl', 'de'],
  },

  IDENTITY_PROVIDERS: {
    itsme: false,
    veriff: true,
  },

  FEATURES: {
    searchMenu: false,
  },

  VITRINE_URL: 'https://bailo.be',

  // TODO: SECURITY - Inject via CI/CD environment variables
  GOOGLE_MAPS_API_KEY: 'AIzaSyA4s5KmUyZ8uvXiWA3RMmKoNoKTxIh9nO8',

  AUTH0: {
    domain: 'auth.bailo.be',
    // TODO: SECURITY - Inject via CI/CD environment variables
    clientId: '395ROGYK9aHj4MnUMtRDscY4icWlpsnj',
    cacheLocation: 'localstorage',
    authorizationParams: {
      audience:
        'https://bailoapi-app-20250826203204.calmgrass-23d7e508.francecentral.azurecontainerapps.io/',
      redirect_uri: window.location.origin,
    },
    httpInterceptor: {
      allowedList: [
        {
          uri: 'https://bailoapi-app-20250826203204.calmgrass-23d7e508.francecentral.azurecontainerapps.io/*',
          // TODO: SECURITY - should be false in production
          allowAnonymous: true,
        },
      ],
    },
  },
};
